import { TransactionDetail } from '../../../models/transaction';

const LEGACY_OPERATIONAL_TO_WORKFLOW: Record<string, string> = {
  AGUARDANDO_ANALISE: 'IN_REVIEW',
  EM_ANALISE: 'IN_REVIEW',
  EM_LIBERACAO: 'APPROVED',
  PAGAMENTO_APROVADO: 'APPROVED',
  PAGAMENTO_REPROVADO: 'REJECTED',
  PAGO_COMPROVANTE: 'PAID',
  ENCERRADO_NEGATIVO: 'REJECTED',
};

export function mapLegacyOperationalToWorkflow(op?: string): string {
  return LEGACY_OPERATIONAL_TO_WORKFLOW[String(op || '').toUpperCase()] || 'IN_REVIEW';
}

function isKnownWorkflowStage(value: string, stageOptions: { value: string }[]): boolean {
  return stageOptions.some((o) => o.value === value);
}


export function resolveInitialWorkflowDraft(
  d: TransactionDetail,
  stageOptions: { value: string }[]
): string {
  let wf = d.workflow_stage ? String(d.workflow_stage) : '';
  if (!wf || !isKnownWorkflowStage(wf, stageOptions)) {
    wf = mapLegacyOperationalToWorkflow(d.operational_status);
  }
  if (!isKnownWorkflowStage(wf, stageOptions)) {
    wf = 'IN_REVIEW';
  }
  return wf;
}
